module.exports = __webpack_public_path__ + "files/354e2a9c5d9499a3c38e8236ac4a385b.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lato-bold-webfont.woff2
 ** module id = 923
 ** module chunks = 0
 **/